import React from 'react';

const ArrowRightRotate2Icon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" stroke="#C3C5CA" fill="none" {...rest}>
      <path d="M14 2.60256V14.5M14 14.5L1 1.5M14 14.5H2.10256" strokeWidth="2.2"/>
    </svg>
  );
};

export default ArrowRightRotate2Icon;